var _module_exports ="<div class=\"gov-closed-tag\">\n    <div class=\"label label-gray\">\n        <i class=\"fa fa-ban fa-align\"></i>\n        &nbsp;Closed\n    </div>\n</div>";;
var path = '/app/shared/components/directives/govClosedTag.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;